// New Relic Browser adapter. The host page installs the agent as `window.newrelic`; a page
// without it (local dev, tests, a host that has not loaded the agent) gets a no-op.

/**
 * Report a handled error, so a failure we recover from is still visible in New Relic
 * (`JavaScriptError`, with these attributes) instead of disappearing or surfacing as an
 * unhandled rejection.
 * @param {Error} error
 * @param {Object} [attributes] - flat values only, e.g. `{ maaOperation: 'saveMessage' }`.
 */
export const noticeError = (error, attributes) => {
  if (typeof window === 'undefined' || typeof window.newrelic?.noticeError !== 'function') return;
  window.newrelic.noticeError(error, attributes);
};
